<template>
    <div class="mt-4 mb-1 font-medium" data-cy="container_serial_available_info">
        <div
            class="text-center font-medium font-main-medium"
            v-if="serialModel.redeemTimestamp != '' && serialModel.redeemTimestamp != null"
            data-cy="container_serial_available_info_redeem"
        >
            <span class="text-dark-10 text-sm" data-cy="text_serial_available_info_redeem_label">{{ lbl.serial.redeem_on }} : </span>
            <span
                class="text-sm text-red-500"
                data-cy="text_serial_available_info_redeem_value"
            >{{ formatDate(serialModel.redeemTimestamp, 'dd/MM/yy - HH:mm') }}</span>
        </div>
        <div
            class="text-center font-medium font-main-medium"
            v-if="serialModel.expiresDate != '' && serialModel.expiresDate != null"
            data-cy="container_serial_available_info_expire"
        >
            <span class="text-dark-10 text-sm" data-cy="text_serial_available_info_expire_label">{{ lbl.serial.valid_through }} : </span>
            <span class="text-sm text-red-500" data-cy="text_serial_available_info_expire_value">{{ formatDate(serialModel.expiresDate, 'dd/MM/yy') }}</span>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin"
import DatetimeHelper from "@/helper/DatetimeHelper"
export default {
    name: 'SerialAvailableInfo',
    inject: ["model"],
    props: {},
    components: {},
    mixins: [LocaleMixin],
    emits: [],
    data: function () { return {} },
    computed: {
        serialModel: function () {
            //console.log(this.model)
            return this.model
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        formatDate: function (val, format) {
            return DatetimeHelper.getDatetimeFullFormat(val, format)
        }
    }
}
</script>
